import React from "react";
import { Modal, FormActions } from "../../../../secondary";
import styles from "../Ne1.module.scss";

export const Ne1StatusHeader = ({
  customerData,
  ne1State,
  popupSave,
  makeShiftSold,
  showConfirmPopup,
  onClickStatus,
  onModalOpen,
  onModalClose,
  onSavePopup,
  onCancelPopup,
}) => (
  <div className={styles.status_bar}>
    {showConfirmPopup && customerData?.accountGroup === "Z002" && (
      <Modal
        modalOpen={true}
        modalClose={onModalClose}
        heading={"NE1 Settings"}
        className={"modal_box"}
        modalScroll={false}
        custom_heading={styles.custom_heading_ne1}
        modal_title={styles.modal_title_modal}
        close={styles.close_button_modal}
      >
        <div>
          <div className={styles.modal_header}>
            <i className={`fa fa-cog ${styles.modal_icon}`} aria-hidden="true"></i>
            <p className={styles.modal_lead}>Apply to all Sold To’s & Ship To’s</p>
          </div>
          <div className={styles.modal_body}>
            <h1 className={styles.modal_state_title}>{ne1State === 1 ? "Enable NE1" : "Disable NE1"}</h1>
            <p className={styles.modal_hint}>
              Please click “Yes” if you wish to apply these parameters to the entire org hierarchy or “No” to cancel
            </p>
          </div>
          <FormActions
            primaryLabel={"Yes"}
            primaryId="yes_popup"
            primaryTestId="yes_popup"
            onPrimaryClick={onSavePopup}
            secondaryLabel={"No"}
            secondaryId="no_popup"
            secondaryTestId="no_popup"
            secondaryVariant="outline"
            onSecondaryClick={onCancelPopup}
          />
        </div>
      </Modal>
    )}

    <div className={styles.status_group}>
      <h2 className={styles.status_title}>NE1 - Paid:</h2>
      {!popupSave && (
        <label className={styles.toggle}>
          <input type="checkbox" name="isStatus" id="isStatus" data-testid="toggleSwitch" checked={ne1State === 1} onChange={onClickStatus} />
          <span className={styles.toggle_slider}></span>
        </label>
      )}
      {popupSave && (
        <div className={styles.applied_state}>
          <span className={styles.applied_badge}>{ne1State === 1 ? "Enabled" : "Disabled"}</span>
          <span className={styles.applied_tick}>
            <i className="fa fa-check" aria-hidden="true"></i>
            Applied to all Sold To’s & Ship To’s
          </span>
        </div>
      )}
    </div>

    {!popupSave && makeShiftSold && customerData?.accountGroup === "Z002" && <div className={styles.divider}></div>}
    {!popupSave && makeShiftSold && customerData?.accountGroup === "Z002" && (
      <button type="button" id="ShiftSold" className={styles.apply_all_btn} onClick={onModalOpen}>
        {"Apply to all Sold To’s and Ship To’s​"}
      </button>
    )}
  </div>
);
